import { render, staticRenderFns } from "./distributionLogNew.vue?vue&type=template&id=8cf58626&scoped=true&"
import script from "./distributionLogNew.vue?vue&type=script&lang=js&"
export * from "./distributionLogNew.vue?vue&type=script&lang=js&"
import style0 from "./distributionLogNew.vue?vue&type=style&index=0&id=8cf58626&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf58626",
  null
  
)

component.options.__file = "distributionLogNew.vue"
export default component.exports